import axios from "axios";
import { BASE_URL, FAF_AUTH, PARTNER_AUTH, CPR_AUTH, CPR_BROWSERID, FAF_BROWSERID, SALESFORCE_BASE_URL, EDUCATION_RESOURCE_DIRECTORY } from "../constant/Constants";
import axiosCall from "./axiosCall";
import { encrypt, decrypt } from "./cryptoService"
import { resetSessionTiming } from "./sessionManagement";

//Get Applications list
export const fetchApplicationLists = async ({ Program, EIN , paramData}) => {
  let authorization = Program == 'CPR' ? CPR_AUTH : FAF_AUTH;
  const payload = paramData == "" ? `ProviderID=E-${EIN}` : `ProviderID=E-${EIN}&${paramData}`
  const response = await axiosCall('get', `/v1/data/D_ApplicationsList?`, authorization, payload, null, Program);
  return { res: response?.data?.pxResults, prg: Program }
}

//Get Fund list
export const fetchFilterFundLists = async ({ Program, EIN }) => {
  let authorization = Program == 'CPR' ? CPR_AUTH : FAF_AUTH;
  const response = await axiosCall('get', `/v1/data/D_GroupAppsbyFundID?`, authorization, `ProviderID=E-${EIN}`, null, Program);
  return { res: response?.data?.pxResults, prg: Program }
}

// Get Recent Activities
export const fetchRecentActivities = async ({ preAuth, ProviderID }) => {
  const response = await axiosCall('get', `v1/data/D_RecentActions?`, preAuth, `ProviderID=${ProviderID}`, null, null);
  return response.pxResults
}

// Get Action Required
export const fetchRequiredActions = async ({ Program, EIN }) => {
  let authorization = Program == 'CPR' ? CPR_AUTH : FAF_AUTH;
  const response = await axiosCall('get', `/v1/data/D_RequiredActions?`, authorization, `ProviderID=E-${EIN}`, null, Program);
  return response?.data?.pxResults
}
// Ge Resourece dropdown value 
export const getResourceService = async (accessToken) => {
  resetSessionTiming()
  let Program = "salesforce"
  let headers = {
    "Accept": "application/json",
    "Authorization": `Bearer ${accessToken}`
    // "Authorization": `Bearer 00D590000000Mv4!AQEAQLhLzCE9Y_FYCb9DwEMkzm6zJsHVqeloLm5auF1h7CJEfvQRfuC9.rjau6M47a2rVtb99q_lWcqQJYUURCf.9RhwelSb`
  }
  // const response = await axiosCall('get', `resource-directory/services/apexrest/getResource`, headers, null, null, Program);
  const response = await axios({
    method: "get",
    url: `${SALESFORCE_BASE_URL}resource-directory/services/apexrest/getResource`,
    headers: headers,
    params: null,
    data: null
  });
  return response
}

// send document email 
export const sendEmailService = async ({ email, content }) => {
  resetSessionTiming()
  let Program = "email"
  var bodyFormData = new FormData();
  bodyFormData.append('email', email);
  bodyFormData.append('content', content);
  const response = await axiosCall('post', `${SALESFORCE_BASE_URL}rd/email.php`, null, null, bodyFormData, Program);
  return response
}
//  Get Resource Articles Service dropdown value 
export const getResourceArticlesService = async ({ accessToken, params }) => {
  resetSessionTiming()
  let Program = "salesforceParam"
  let headers = {
    "Accept": "application/json",
    "Authorization": `Bearer ${accessToken}`
    // "Authorization": `Bearer 00D4C0000000xHX!AQEAQGePCGCjdwXKQCwJPnDXtnk_Arj_KSFNErCnzU.9wNvuySF.BQuvtoAVrPd0k2m5Hdka2AbZggevMU2VxymdgrpuNL5q`
  }

  // const response = await axiosCall('get', `resource-directory/services/apexrest/getResourceArticles/?`, headers, params, null, Program);

  const response = await axios({
    method: "get",
    url: `${SALESFORCE_BASE_URL}resource-directory/services/apexrest/getResourceArticles/?${params}`,
    headers: headers,
    params: null,
    data: null
  });
  return response
}

// Get Portal Messages For Partner portal message, we are using FAF API because its configured in FAF Internal portal.
export const fetchPortalMessages = async (preAuth) => {
  resetSessionTiming()
  const response = await axiosCall('get', `/v1/data/D_MessageCenterList`, FAF_AUTH, null, null, "FAF");
  const response2 = await axiosCall('get', `/v1/data/D_MessageCenterList`, CPR_AUTH, null, null, "CPR");

  return { faf: response.data.pxResults, cpr: response2.data.pxResults }
}

// Get Lookup values
export const fetchLookup = async (prgData) => {
  resetSessionTiming()
  let CPR_LookUpQuery = `"state","PLTP01","FGP01","PREL01","CORRPREF01","CPRDIAg","RELPro01","INST01","HLTP01","RACE01","PREME01", "TreatSet", "PhySpe", "CoPRo", "EMP01","GEN01", "YN01", "MS01"`;
  let FAF_LookUpQuery = `"state","PLTP01","FGP01","PREL01","CORRPREF01","FAFDIAg","RELPro01","INST01","HLTP01","RACE01","PREME01", "TreatSet", "PhySpe", "CoPRo", "EMP01","GEN01", "YN01", "MS01"`;
  let authorization = prgData == 'CPR' ? CPR_AUTH : FAF_AUTH;
  let browserID = prgData == 'CPR' ? CPR_BROWSERID : FAF_BROWSERID;
  let query = prgData == 'CPR' ? CPR_LookUpQuery : FAF_LookUpQuery;
  const response = await axiosCall('get', `/v1/data/D_GetLookUpValuesByID?`, authorization, `BrowserID='${browserID}'&LookUpID=${query}`, null, prgData);
  return { res: response.data.pxResults, Program: prgData }
}

export const educationResource = async (params) => {
  let Program = params == null ? "email" : "ERDParam"
  // const response = await axiosCall('post', `https://portalapi.patientadvocate.org/educationrd/resource-dir.php/?`, null, params, null, Program);
  const response = await axios({
    method: "post",
    url: `${EDUCATION_RESOURCE_DIRECTORY}/?${params}`,
    headers: null,
    params: null,
    data: null
  });
  return response.data
}